// @core/api/endpoints/workflow/test_prompt_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TestPromptTemplateRequest,
  TestPromptTemplateResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Test prompt template
 * Renders the template's system and user messages with the given variable values and reports unresolved placeholders. No model is called.
 */
export async function TestPromptTemplate(
  template_id: string,
  data: TestPromptTemplateRequest,
  options?: RequestOptions
): Promise<TestPromptTemplateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/prompt-templates/:template_id/test`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.post<TestPromptTemplateResponse>(requestPath, data, requestOptions);
}
